export default __webpack_public_path__ + "static/media/Group 129.8d362c23.png";